function getNumRecords(numPages: number, recordsPerPage: number): number {
    return numPages * recordsPerPage;
}

function getNewMaxPageIndex(currentNumPages: number, currentRecordsPerPage: number, newRecordsPerPage: number): number {
    return Math.ceil(getNumRecords(currentNumPages, currentRecordsPerPage) / newRecordsPerPage) - 1;
}

/**
 * Determines the index of the first record appearing on the given page.
 * @param pageSize The number of records per page
 * @param pageIndex The current zero-based page index.
 * @returns The zero-based record index of the first record appearing on the page.
 */
function getFirstRecordOfPage(pageSize: number, pageIndex: number): number {
    return pageSize * pageIndex;
}

function getNewPageIndex(
    pageIndex: number, 
    currentPageSize: number, 
    newPageSize: number): number {
        return Math.floor(getFirstRecordOfPage(currentPageSize, pageIndex) / newPageSize);
}

export { getNumRecords, getNewMaxPageIndex, getNewPageIndex };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/pagination.ts